export default (to, from, next) => {
    if (to.path !== '/login') {
        if (localStorage.getItem('access_token') != null && localStorage.getItem('access_token').length > 0) {
            axios.get('/api/auth-user')
                .then(() => next())
                .catch(() => {
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user_info');
                    next('/login');
                });
        } else {
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_info');
            next('/login');
        }
    }
}
